import TaticaClientePng from "./imgs/tatica_cliente.png";
import PagueFlexPng from "./imgs/pague_flex.png";
import CapPng from "./imgs/cap.png";
import Lemontech from './imgs/lemontech.png';
import Fiori from './imgs/fiori.png';
import Concur from './imgs/concur.png';
import MatrixIcon from './imgs/matrix.png';
import ObraIcon from './imgs/mapaObra.png';
import Vend from './imgs/vend.png';
import Apoio from './imgs/apoio.png';
import Dtm from './imgs/logo_dtm.png';
import LabMovel from './imgs/laboratorio-movel.png';
import Votorantim from './imgs/votorantim.png';
import TelefonesLinks from './imgs/tels.webp';
import TelefonesTivit from './imgs/telefones_tivit.png';
import Tivit from './imgs/tivit_icon.png';
import Contatos from './imgs/contatos.png';
import marcacaoReflex from './imgs/marcacao.png';
import reflexSemTagline from './imgs/logo-reflex-sem-tagline.png';
export const TaticaCliente = () => <img src={TaticaClientePng} />;
export const MarcacaoReflex = () => <img src={marcacaoReflex} />;
export const Telefones = () => <img src={TelefonesLinks} />;
export const PagueFlex = () => <img src={PagueFlexPng} />;
export const CapIcon = () => <img src={CapPng} />;
export const LemontechIcon = () => <img src={Lemontech} />;
export const FioriIcon = () => <img src={Fiori} />;
export const ConcurIcon = () => <img src={Concur} />;
export const Matrix = () => <img src={MatrixIcon} />
export const MapaObra = () => <img src={ObraIcon} />
export const VendMais = () => <img src={Vend} />
export const ApoioVendMais = () => <img src={Apoio} />
export const TreinamentoDtm = () => <img src={Dtm} />
export const LaboratorioMovel = () => <img src={LabMovel} />
export const VotorantimLogo = () => <img src={Votorantim} />
export const TellsTivit = () => <img src={TelefonesTivit} />
export const TivitIcon = () => <img src={Tivit} />
export const ContatosIcon = () => <img src={Contatos} />
export const ReflexIconSemTagline = () => <img src={reflexSemTagline} />